import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Что-то пошло не так',
  subtitle: 'Попробуйте отправить форму позже',
  actions: {
    close: 'Понятно',
  },
} satisfies TMessages
